import { track } from "./events";

// Visible time since this page load, in milliseconds. A teacher can leave an
// item open while the phone is locked or another app is in front; elapsed
// wall-clock time then says nothing about engagement, so durations are
// reported alongside the time the page was actually in view.
let visibleMs = 0;
let visibleSince: number | null = document.visibilityState === "hidden" ? null : Date.now();

export function activeMilliseconds(): number {
  return visibleMs + (visibleSince === null ? 0 : Date.now() - visibleSince);
}

// Seconds the page was in view since `startMs`, a value from activeMilliseconds().
export function activeSecondsSince(startMs: number): number {
  return Math.round((activeMilliseconds() - startMs) / 1000);
}

document.addEventListener("visibilitychange", () => {
  const hidden = document.visibilityState === "hidden";
  if (hidden && visibleSince !== null) {
    visibleMs += Date.now() - visibleSince;
    visibleSince = null;
  } else if (!hidden && visibleSince === null) {
    visibleSince = Date.now();
  }
  track(hidden ? "tab_hidden" : "tab_visible", {
    payload: { active_seconds: Math.round(activeMilliseconds() / 1000) },
  });
});
